/** @format */
import {
    largeDesktop,
    largeTablet,
    mobile,
    smallTablet,
} from '@mpb-com/feather/helpers/media-queries';
import styled, { css } from 'styled-components';

export const StyledVideoBlock = styled.div`
    /* We always want this to be full width, so break out of the constrained wrapper */
    grid-column: 1 / -1 !important;
    background-color: var(--colors-surface-inverse);

    .video {
        height: 60rem;
        grid-column: 1 / -1 !important;
        iframe {
            border: 0;
        }
    }

    .content {
        padding: var(--layout-spacing-48) 0;
        display: grid;
        grid-template-areas:
            'heading heading'
            'call-to-actions description';
        grid-template-columns: min-content 1fr;
        grid-row-gap: var(--layout-spacing-24);
        grid-column-gap: var(--layout-spacing-48);

        .heading {
            margin-bottom: var(--layout-spacing-8);
            grid-area: heading;
        }

        .call-to-action-container {
            grid-area: call-to-actions;
            display: flex;
            flex-direction: column;
            min-width: 18rem;

            > :first-of-type {
                margin-bottom: var(--layout-spacing-24);
            }

            button {
                width: 100%;
                white-space: nowrap;
            }
        }

        .description {
            grid-area: description;
            margin: 0;
            color: var(--colors-text-inverse);

            strong {
                color: var(--colors-text-accent-inverse);
            }
        }
    }

    ${largeDesktop(css`
        padding-top: var(--layout-spacing-48);
        .video {
            /* override the full width grid col */
            grid-column: 2 !important;
        }
    `)};

    ${largeTablet(css`
        .video {
            height: 45rem;
        }

        .content {
            padding: var(--layout-spacing-48) 0;
            grid-template-areas:
                'heading'
                'description'
                'call-to-actions';
            grid-template-columns: auto;

            .call-to-action-container {
                flex-direction: row;
                flex-wrap: wrap;

                > * {
                    min-width: 20rem;
                    &:first-of-type {
                        margin-right: var(--layout-spacing-24);
                    }
                }
            }
        }
    `)}

    ${smallTablet(css`
        .video {
            height: 35rem;
        }

        .content {
            padding: var(--layout-spacing-32) 0;
            .call-to-action-container {
                flex-direction: column;

                > :first-of-type {
                    margin: 0 0 var(--layout-spacing-24) 0;
                }
            }
        }
    `)}

    ${mobile(css`
        .video {
            height: 25rem;
        }
    `)}
`;
